import { State } from 'App/state/rootState';

export const headerExpandedSelector = (state: State) => state.headerExpanded;
